import { render, staticRenderFns } from "./CommunicationMoreInfo.vue?vue&type=template&id=45cb8b22&"
import script from "./CommunicationMoreInfo.vue?vue&type=script&lang=js&"
export * from "./CommunicationMoreInfo.vue?vue&type=script&lang=js&"
import style0 from "./CommunicationMoreInfo.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports